import { create } from 'zustand';
// import * as Realm from 'realm-web';
import getDiffDate from '@functions/getDiffDate';
import { useStoreOrderCategory } from './useStoreOrderCategory';

// const REALM_APP_ID = import.meta.env[
//   `VITE_REACT_APP_REALM_CONFIGURATION_${import.meta.env.MODE}`
// ];
// const realmApp = new Realm.App({ id: REALM_APP_ID });
import moment from 'moment-timezone';
import { getCredsFromStorage } from '@data/localStorageGetter';

const EXPIRED_MINUTES = 30; // default 30 menit
const getSearchParam = window.location.href.split('?')[1];
const getTokenFromURL = () => {
  if (getSearchParam) {
    const newUrl = getSearchParam.replace(/&amp;/g, '&');

    const urlToken = new URLSearchParams(`?${newUrl}`).get('token');
    const urlUUID = new URLSearchParams(`?${newUrl}`).get('uuid');
    const urlTable = new URLSearchParams(`?${newUrl}`).get('table');
    const urlSicc = new URLSearchParams(`?${newUrl}`).get('sicc');
    // CRM-scan attribution: when the CRM mobile app's "Scan Table" feature
    // scans the table QR, it appends ?crm_member_uid=<id_customer> to the URL.
    // The shortener landing's resolveQueryParams() carries it through the
    // redirect (same path the sicc param rides), so it lands here verbatim.
    // The value is opaque to us — CRM resolves it to the member server-side.
    const urlCrmMember = new URLSearchParams(`?${newUrl}`).get('crm_member_uid');
    const urlMiniappCHeck = new URLSearchParams(`?${newUrl}`).get('miniapp');
    // The short-URL alias this page was opened from, appended by the shortener landing
    // (lambda-shortener 0.1.12). Sent with every order as qr_alias: after the table's QR
    // is refreshed (e.g. when the POS closes the bill) the old alias is refused, so a page
    // left open from the old QR cannot keep ordering on the table.
    const urlQrAlias = new URLSearchParams(`?${newUrl}`).getAll('sc').pop() || null;
    if (urlToken && urlUUID) {
      let loginStamp = moment(new Date()).format('x');
      const result = {
        'login-stamp': loginStamp,
        token: urlToken,
        uuid: urlUUID || urlTable,
        sicc: urlSicc,
        crm_member_uid: urlCrmMember,
        qr_alias: urlQrAlias,
        miniapp: Boolean(urlMiniappCHeck),
      };

      return result;
    }
  }
};

export const useStoreFirstCredential = create((set, get) => ({
  credentials: getTokenFromURL() || getCredsFromStorage() || {},
  updateCredentials: (newCreds) => {
    set({ credentials: newCreds });
  },
  getCredentials: () => {
    return get().credentials;
  },
  checkValidCredentials: () => {
    let validCred = {};
    let credential = get().credentials;
    if (
      credential.token !== null &&
      credential.token !== '' &&
      credential.uuid !== null &&
      credential.uuid !== ''
    ) {
      validCred = credential;
    } else {
      if (import.meta.env.MODE !== 'PRODUCTION') {
        console.log('Dont have credential');
      }
    }
    return validCred;
  },
  checkTokenIsExpired: () => {
    const credential = get().credentials;
    let loginStamp = credential?.['login-stamp'];

    if (!loginStamp) return true;

    let diffMinutes = getDiffDate(+loginStamp);

    if (diffMinutes === null) return true;
    // TOKEN EXPIRED FRONTEND DISET 30 MENIT, KETIKA LEBIH DARI ITU, HARUS CLEAR STORAGE
    return diffMinutes >= EXPIRED_MINUTES;
  },
  // getUserLogin: async () => {
  //   ///check payload kalo ada isinya login, kalo {} berhenti
  //   const credentials = Realm.Credentials.function(get().credentials);
  //   if (getSearchParam) {
  //     if (credentials.payload.uuid) return await realmApp.logIn(credentials);
  //     return;
  //   } else {
  //     let user = realmApp.currentUser;
  //     if (user) {
  //       return user;
  //     } else {
  //       if (credentials.payload.uuid) return await realmApp.logIn(credentials);
  //       return;
  //     }
  //   }
  // },
  isLoggedIn: () => {
    if (get().credentials && useStoreOrderCategory.getState().orderCategory) {
      return true;
    } else {
      return false;
    }
  },
}));
